// Libs
import classNames from 'classnames/bind';
import { Box, Stack } from '@mui/material';
// Components, Layouts, Pages

import { ListConversation } from '~/components/module/conversation';
// Others
// Styles, images, icons
import styles from './CommunicationTextMessages.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const CommunicationTextMessages = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack component={'div'} id='communicationTextMessagesComponent' className={cx('container')}>
      <Stack component={'div'} direction={'row'} className={cx('body')}>
        <Box component={'div'} className={cx('listConversation')}>
          <ListConversation />
        </Box>

        <Box component={'div'} className={cx('messageConversation')}></Box>
      </Stack>
    </Stack>
  );
};

export default CommunicationTextMessages;
